import _regeneratorRuntime from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/builds/karvy/dit-react/packages/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { CALL_API } from "../api.middleware";
import { SHOW_PURCHASE_CONFIRMATION, SHOW_PURCHASE_CONFIRMATION_SUCCESS, SHOW_PURCHASE_CONFIRMATION_FAILED, CONFIRM_PURCHASE, CONFIRM_PURCHASE_SUCCESS, CONFIRM_PURCHASE_FAILED, SET_SIP_DETAILS, SIP_SAVE_DATA, SIP_SAVE_DATA_SUCCESS, SIP_SAVE_DATA_FAILED, SET_SWITCH_DETAILS, SET_STP_DETAILS, GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED } from "../types";
export var submitPurchaseData = function submitPurchaseData(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SentpurchasemailRed",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", {
                  error: _context.t0
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};
export var showPurchaseConfirmation = function showPurchaseConfirmation(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/ShowpurchaseconfirmationData",
                  params: params,
                  method: "GET",
                  types: [SHOW_PURCHASE_CONFIRMATION, SHOW_PURCHASE_CONFIRMATION_SUCCESS, SHOW_PURCHASE_CONFIRMATION_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", {
                  error: _context2.t0
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
export var saveSipData = function saveSipData(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SIPSave",
                  params: params,
                  method: "GET",
                  types: [SIP_SAVE_DATA, SIP_SAVE_DATA_SUCCESS, SIP_SAVE_DATA_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", {
                  error: _context3.t0
                });

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }()
  );
};
export var confirmPurchase = function confirmPurchase(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(dispatch) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SaveDTRWeb",
                  params: params,
                  method: "GET",
                  types: [CONFIRM_PURCHASE, CONFIRM_PURCHASE_SUCCESS, CONFIRM_PURCHASE_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", {
                  error: _context4.t0
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 6]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};
export var getAssetClasses = function getAssetClasses(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(dispatch) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetAssetclass",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", {
                  error: _context5.t0
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 6]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
};
export var getOtherSchemes = function getOtherSchemes(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(dispatch) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/getOtherSchemesSwitch",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", {
                  error: _context6.t0
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 6]]);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};
export var getBankDetails = function getBankDetails(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref7 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(dispatch) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetRedemptionBankDeatils",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", {
                  error: _context7.t0
                });

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 6]]);
      }));

      return function (_x7) {
        return _ref7.apply(this, arguments);
      };
    }()
  );
};
export var getCheckPanAotm = function getCheckPanAotm(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref8 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(dispatch) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/CheckPANAotm",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8["catch"](0);
                alert("".concat(_context8.t0));

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[0, 6]]);
      }));

      return function (_x8) {
        return _ref8.apply(this, arguments);
      };
    }()
  );
};
export var getRedemptionPaymentDetails = function getRedemptionPaymentDetails(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref9 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(dispatch) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/exitloadcalc",
                  params: params,
                  method: "GET",
                  showLoader: true,
                  types: [SHOW_PURCHASE_CONFIRMATION, SHOW_PURCHASE_CONFIRMATION_SUCCESS, SHOW_PURCHASE_CONFIRMATION_FAILED]
                }));

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 6:
                _context9.prev = 6;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", {
                  error: _context9.t0
                });

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[0, 6]]);
      }));

      return function (_x9) {
        return _ref9.apply(this, arguments);
      };
    }()
  );
};
export var redemptionConfirm = function redemptionConfirm(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref10 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(dispatch) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/Savetransaction_red",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 6:
                _context10.prev = 6;
                _context10.t0 = _context10["catch"](0);
                alert("".concat(_context10.t0));

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 6]]);
      }));

      return function (_x10) {
        return _ref10.apply(this, arguments);
      };
    }()
  );
};
export var swpOptions = function swpOptions(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref11 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(dispatch) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/getMasterSIP",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context11.abrupt("return", _context11.sent);

              case 6:
                _context11.prev = 6;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", {
                  error: _context11.t0
                });

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 6]]);
      }));

      return function (_x11) {
        return _ref11.apply(this, arguments);
      };
    }()
  );
};
export var CalcSIPEnddt = function CalcSIPEnddt(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref12 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(dispatch) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/CalcSIPEnddt",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context12.abrupt("return", _context12.sent);

              case 6:
                _context12.prev = 6;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", {
                  error: _context12.t0
                });

              case 9:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 6]]);
      }));

      return function (_x12) {
        return _ref12.apply(this, arguments);
      };
    }()
  );
};
export var swpConfirm = function swpConfirm(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref13 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(dispatch) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SWPDetailsSave_WEB",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context13.abrupt("return", _context13.sent);

              case 6:
                _context13.prev = 6;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", {
                  error: _context13.t0
                });

              case 9:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, null, [[0, 6]]);
      }));

      return function (_x13) {
        return _ref13.apply(this, arguments);
      };
    }()
  );
};
export var stpConfirm = function stpConfirm(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref14 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(dispatch) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                _context14.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/SaveSTPconfirmationWeb",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 6:
                _context14.prev = 6;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", {
                  error: _context14.t0
                });

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, null, [[0, 6]]);
      }));

      return function (_x14) {
        return _ref14.apply(this, arguments);
      };
    }()
  );
};
export var physicalTransaction = function physicalTransaction(body) {
  return (
    /*#__PURE__*/
    function () {
      var _ref15 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(dispatch) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "",
                  body: body,
                  method: "POST",
                  isFile: true,
                  showLoader: true
                }));

              case 3:
                return _context15.abrupt("return", _context15.sent);

              case 6:
                _context15.prev = 6;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", {
                  error: _context15.t0
                });

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, null, [[0, 6]]);
      }));

      return function (_x15) {
        return _ref15.apply(this, arguments);
      };
    }()
  );
};
export var setSipDetails = function setSipDetails(data) {
  return {
    type: SET_SIP_DETAILS,
    body: data
  };
};
export var setSwitchDetails = function setSwitchDetails(data) {
  return {
    type: SET_SWITCH_DETAILS,
    body: data
  };
};
export var setStpDetails = function setStpDetails(data) {
  return {
    type: SET_STP_DETAILS,
    body: data
  };
};
export var getFundWiseEarnings = function getFundWiseEarnings(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref16 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(dispatch) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetBrokerageDetails",
                  params: params,
                  method: "GET",
                  types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
                  showLoader: true
                }));

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 6:
                _context16.prev = 6;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", {
                  error: _context16.t0
                });

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[0, 6]]);
      }));

      return function (_x16) {
        return _ref16.apply(this, arguments);
      };
    }()
  );
};
export var getMinimumAmount = function getMinimumAmount(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref17 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(dispatch) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                _context17.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/Ktrack_GetMinAmt",
                  params: params,
                  method: "GET" // types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
                  // showLoader: true

                }));

              case 3:
                return _context17.abrupt("return", _context17.sent);

              case 6:
                _context17.prev = 6;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", {
                  error: _context17.t0
                });

              case 9:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, null, [[0, 6]]);
      }));

      return function (_x17) {
        return _ref17.apply(this, arguments);
      };
    }()
  );
};
export var getEnach = function getEnach(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref18 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(dispatch) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/enachregdbilldesk",
                  params: params,
                  method: "GET",
                  showLoader: true
                }));

              case 3:
                return _context18.abrupt("return", _context18.sent);

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", {
                  error: _context18.t0
                });

              case 9:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, null, [[0, 6]]);
      }));

      return function (_x18) {
        return _ref18.apply(this, arguments);
      };
    }()
  );
};
export var getNctType = function getNctType(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref19 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(dispatch) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                _context19.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/GetNCTKtrackgo",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context19.abrupt("return", _context19.sent);

              case 6:
                _context19.prev = 6;
                _context19.t0 = _context19["catch"](0);
                alert("".concat(_context19.t0));

              case 9:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, null, [[0, 6]]);
      }));

      return function (_x19) {
        return _ref19.apply(this, arguments);
      };
    }()
  );
};
export var getNctSave = function getNctSave(body) {
  return (
    /*#__PURE__*/
    function () {
      var _ref20 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(dispatch) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                _context20.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "",
                  body: body,
                  method: "POST",
                  isNct: true,
                  showLoader: true
                }));

              case 3:
                return _context20.abrupt("return", _context20.sent);

              case 6:
                _context20.prev = 6;
                _context20.t0 = _context20["catch"](0);
                alert("".concat(_context20.t0));

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, null, [[0, 6]]);
      }));

      return function (_x20) {
        return _ref20.apply(this, arguments);
      };
    }()
  );
};
export var getCheckPanKotm = function getCheckPanKotm(params) {
  return (
    /*#__PURE__*/
    function () {
      var _ref21 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee21(dispatch) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return dispatch(_defineProperty({}, CALL_API, {
                  url: "/CheckPANKotm",
                  params: params,
                  method: "GET"
                }));

              case 3:
                return _context21.abrupt("return", _context21.sent);

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);
                alert("".concat(_context21.t0));

              case 9:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, null, [[0, 6]]);
      }));

      return function (_x21) {
        return _ref21.apply(this, arguments);
      };
    }()
  );
};